import FormuleArchivesController from './formule.archives.controller';

export default {
	bindings: {
		produit: '=',
		formules: '=',
		onUpdate: '&',
		formule: '<'
	},
	template: require('./formule.archives.html'),
	controller: FormuleArchivesController
};
